import { useState, useEffect } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import '../table-columns/table-columns.scss';
import { alphanumericSort2 } from '../../../innovation/utils/utils';

interface StaticValue {
  value: number;
  alias: string;
}
export default function ToplineSelectInputBox({
  formattedValue,
  globalResetFlag,
  selectValues,
  inputsDisabled = false,
  handleSelectChange,
}: {
  formattedValue: number | string;
  globalResetFlag: boolean;
  selectValues: StaticValue[];
  inputsDisabled?: boolean;
  handleSelectChange: (value: number) => void;
}) {
  const [value, setValue] = useState(formattedValue);

  const handleValueChange = e => {
    const val = e.target.value;
    setValue(val);
    handleSelectChange(val);
  };

  useEffect(() => {
    setValue(formattedValue);
  }, [formattedValue, globalResetFlag]);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <Select
        value={value}
        onChange={handleValueChange}
        disabled={inputsDisabled}
        displayEmpty
        style={{
          width: '120px',
          height: '30px',
          border: '1px solid transparent',
          textAlign: 'left',
          fontSize: '12px',
        }}
        inputProps={{ 'aria-label': 'Without label' }}
      >
        {selectValues &&
          selectValues.length > 0 &&
          alphanumericSort2(selectValues).map(option => (
            <MenuItem
              key={option.value}
              value={option.value}
              style={{ fontSize: '12px' }}
            >
              {option.alias}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
